import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import { useStores } from '../../../recipes';
import { TestIds } from '../../../test-utils/tests.consts';

interface Props {
	teamId: number;
}

const TeamNameCell = ({ teamId }: Props) => {
	const {
		teamsStore: { get: getTeamById }
	} = useStores();
	const { t } = useTranslation();

	if (!teamId) {
		return <span data-test-id={TestIds.TEAM_NAME_CELL}>{t('EXCEPTIONS_LIST.UNKNOWN')}</span>;
	}

	const team = getTeamById(teamId);

	return (
		<span data-test-id={TestIds.TEAM_NAME_CELL}>
			{team ? team.name || `${t('EXCEPTIONS_LIST.TEAM')} ${teamId}` : t('EXCEPTIONS_LIST.UNKNOWN')}
		</span>
	);
};

export default observer(TeamNameCell);
